export default __webpack_public_path__ + "static/media/ReviewGood.64ad8de0.svg";